import {
  parseArticleDetail,
  publicArticleDetailSchema,
} from "@general-applications/contracts/content";
import type { ArticleSource } from "@general-applications/contracts/content";
import { isDevMode } from "@/app/common/functions/env/isDevMode";

export const httpArticleSource: ArticleSource = {
  async get(slug, signal) {
    const preview = isDevMode();
    const response = await fetch(
      `/api/articles/${preview ? "preview/" : ""}${encodeURIComponent(slug)}`,
      { signal },
    );
    if (response.status === 404) return null;
    if (!response.ok)
      throw new Response("Article service unavailable", { status: 503 });
    const payload: unknown = await response.json();
    return preview
      ? parseArticleDetail(payload)
      : publicArticleDetailSchema.parse(payload);
  },
};
